module.exports = __webpack_public_path__ + "static/media/new_order_sound.20803996.mp3";